import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/work_instructions',
    name: 'WorkInstruction',
    component: {
      name: 'AdminWorkInstruction',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'work_instruction',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminWorkInstructionIndex',
        component: () => import('../views/WorkInstructionsAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminWorkInstructionNew',
        component: () => import('../views/WorkInstructionAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminWorkInstructionIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminWorkInstructionShow',
        component: () => import('../views/WorkInstructionAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminWorkInstructionIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminWorkInstructionDetails',
            component: () => import('../views/WorkInstructionAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminWorkInstructionEdit',
            component: () => import('../views/WorkInstructionAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminWorkInstructionDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminWorkInstructionAttachments',
            component: () => import('../views/WorkInstructionAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminWorkInstructionAttachmentsEdit',
            component: () => import('../views/WorkInstructionAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'jobs',
            name: 'AdminWorkInstructionJobs',
            component: () => import('../views/job/WorkInstructionAdminJobs.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionDetails' },
              resource: 'job',
            },
          },
          {
            path: 'phases',
            name: 'AdminWorkInstructionPhases',
            component: () => import('../views/WorkInstructionAdminPhases.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminWorkInstructionLogs',
            component: () => import('../views/log/WorkInstructionAdminLogs.vue'),
            meta: {
              backRoute: { name: 'AdminWorkInstructionIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));